import { FormattedMessage } from "react-intl";
import useResponsive from "../../hooks/useResponsive";
import { getShServiceBasePath } from "../../utils/envUtil";
import { useEffect, useState } from "react";
import { Button, Modal } from "@shltelemedicine/shl-ui-lib";
import styles from "./Disclaimer.module.css";
import logo from "../../assets/login/login_logo.svg";

const Disclaimer = () => {
  const { isMobile } = useResponsive();
  const [showTC, setShowTC] = useState(false);

  useEffect(() => {
    document.querySelector("#link")?.addEventListener("click", (e) => {
      e.preventDefault();
      setShowTC(true);
    });
  }, []);

  const onClose = () => setShowTC(false);

  return (
    <>
      <FormattedMessage
        id="AUTH_WARNING"
        defaultMessage="This website is intended for healthcare professionals only.<br></br>Accessing this site confirms you're a healthcare professional and agree to SmartHeart's {link}."
        values={{
          br: () => (isMobile ? " " : <br></br>),
          link: (
            <a id="link" href="">
              terms and conditions
            </a>
          ),
        }}
      />
      <Modal
        show={showTC}
        centered
        backdrop="static"
        dialogClassName={styles.dialog}
        contentClassName="h-100 app-shadow"
        onHide={onClose}
        footer={
          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              backgroundColor: "#F9F9F9",
              borderTop: "1px solid black",
              padding: "10px",
            }}
          >
            <Button
              bgColor="transparent linear-gradient(180deg, #717689 0%, #393B45 100%) 0% 0% no-repeat padding-box"
              className={`${
                isMobile ? styles.actionButton : ""
              } d-flex justify-content-center`}
              style={{ padding: "5px 30px" }}
              onClick={onClose}
            >
              CLOSE
            </Button>
          </div>
        }
      >
        <div style={{ padding: "15px" }}>
          <div className={styles.logoContainer}>
            <img src={logo} />
          </div>
          <iframe
            style={{ height: "50vh" }}
            title="modal-iframe"
            src={`${getShServiceBasePath()}/termsofuse/pro/en-us.html`}
            width="100%"
            frameBorder="0"
          />
        </div>
      </Modal>
    </>
  );
};

export default Disclaimer;
